var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3"},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.message.payload.url,"type":"audio/mp3"}}),_vm._v(" Tu navegador no soporta audio HTML5. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }